var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 60,
    viewBox: "0 0 95 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4703 4.51506L4.6462 22.3392C0.422783 26.5626 0.422783 33.4101 4.6462 37.6335L22.4703 55.4577C26.6937 59.6811 33.5413 59.6811 37.7647 55.4577L55.5888 37.6335C59.8122 33.4101 59.8122 26.5626 55.5888 22.3392L37.7647 4.51506C33.5413 0.291643 26.6937 0.29164 22.4703 4.51506Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0391 15.7578H93.517",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0391 47.0005H93.517",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0996 31.3792H93.517",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4645 26.7365C41.2187 25.8625 40.891 25.0432 40.4541 24.2786L42.4204 20.1547C41.683 19.2535 40.8637 18.4342 39.9625 17.6969L35.8387 19.6632C35.074 19.2262 34.2547 18.8985 33.3808 18.6527L31.8514 14.3377C31.2779 14.2831 30.7044 14.2285 30.1309 14.2285C29.5574 14.2285 28.9566 14.2558 28.4104 14.3377L26.881 18.6527C26.0344 18.8985 25.1878 19.2262 24.4231 19.6632L20.2993 17.6969C19.3981 18.4342 18.5788 19.2535 17.8414 20.1547L19.8077 24.2786C19.3708 25.0432 19.0431 25.8625 18.7973 26.7365L14.4823 28.2658C14.4277 28.8393 14.373 29.4128 14.373 29.9863C14.373 30.5598 14.4004 31.1607 14.4823 31.7069L18.7973 33.2362C19.0431 34.1101 19.3708 34.9294 19.8077 35.6941L17.8414 39.8179C18.5788 40.7192 19.3981 41.5385 20.2993 42.2758L24.4231 40.3095C25.1878 40.7465 26.0071 41.0742 26.881 41.32L28.4104 45.6349C28.9839 45.6896 29.5574 45.7442 30.1309 45.7442C30.7044 45.7442 31.3052 45.7169 31.8514 45.6349L33.3808 41.32C34.2547 41.0742 35.074 40.7465 35.8387 40.3095L39.9625 42.2758C40.8637 41.5385 41.683 40.7192 42.4204 39.8179L40.4541 35.6941C40.891 34.9294 41.2187 34.1101 41.4645 33.2362L45.7795 31.7069C45.8341 31.1334 45.8888 30.5598 45.8888 29.9863C45.8888 29.4128 45.8614 28.812 45.7795 28.2658L41.4645 26.7365V26.7365ZM24.8601 30.2048C24.8601 33.0997 27.2087 35.4483 30.1036 35.4483C32.9984 35.4483 35.3471 33.0997 35.3471 30.2048C35.3471 27.31 32.9984 24.9613 30.1036 24.9613C27.2087 24.9613 24.8601 27.31 24.8601 30.2048Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.7656,
    height: 60,
    fill: "white",
    transform: "translate(0.117188)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOd);
export default __webpack_public_path__ + "static/media/OD.245bac1bc2f39c64bd2800b6524e421d.svg";
export { ForwardRef as ReactComponent };